import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getBillingInformationSelector } from '../billing.reducer';
import { BillingInformation, TaxType } from '../billing';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { UpdateBillingInformationAction } from '../billing.action';
import { markFormAsTouched } from '../../../lead-generation/shared/reactive-forms/forEachElementInForm';
import { BillingService } from '../billing.service';
import { Observable } from 'rxjs';
import { AmplitudeService } from '../../../shared/services/amplitude.service';
import TAX_TYPE_DESCRIPTIONS from './tax.types';

@Component({
  selector: 'cc-billing-information',
  templateUrl: './billing-information.component.html',
  styleUrls: ['./billing-information.component.scss']
})
export class BillingInformationComponent implements OnInit {
  public billingForm: FormGroup;
  public billingInformation: BillingInformation;
  public taxTypes: Observable<TaxType[]>;
  public editMode = false;

  constructor(
    private fb: FormBuilder,
    private store: Store<IState>,
    private billingService: BillingService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.initForm();
    this.taxTypes = this.billingService.getTaxTypes();
    this.store.select(getBillingInformationSelector).subscribe(data => {
      this.billingInformation = data;
      this.fillData();
    });
  }

  private initForm() {
    this.billingForm = this.fb.group({
      name: ['', Validators.required],
      taxType: [''],
      taxId: [''],
      line1: [''],
      line2: [''],
      postalCode: [''],
      city: [''],
      country: [''],
      state: [''],
      phone: [''],
      email: ['']
    });
    this.configureValidation();
  }

  get isFormValid() {
    return this.billingForm.valid;
  }

  private fillData() {
    Object.entries(this.billingInformation).forEach(([key, value]) => {
      if (this.billingForm.controls.hasOwnProperty(key)) {
        this.billingForm.controls[key].setValue(value || '');
      }
    });
  }

  edit() {
    this.amplitudeService.logEvent('Panel:Billing:EditInfo: Start');
    this.editMode = true;
  }

  cancel() {
    this.amplitudeService.logEvent('Panel:Billing:EditInfo: Cancel');
    this.editMode = false;
    this.fillData();
  }

  save() {
    this.amplitudeService.logEvent('Panel:Billing:EditInfo: Save');
    markFormAsTouched(this.billingForm);
    if (this.isFormValid) {
      this.store.dispatch(new UpdateBillingInformationAction(this.billingForm.getRawValue()));
      this.editMode = false;
    } else {
      this.amplitudeService.logEvent('Panel:Billing:EditInfo: Invalid form');
    }
  }

  getTaxTypeDescription(key) {
    return TAX_TYPE_DESCRIPTIONS[key];
  }

  private configureValidation() {
    this.billingForm.get('taxType').valueChanges.subscribe(taxType => {
      const taxIdControl = this.billingForm.get('taxId');
      taxIdControl.setValidators(taxType ? Validators.required : null);
      taxIdControl.updateValueAndValidity();

      const billingAddressControl = this.billingForm.get('line1');
      billingAddressControl.setValidators(taxType ? Validators.required : null);
      billingAddressControl.updateValueAndValidity();
    });
  }
}
